import { render, staticRenderFns } from "./vue-qz-tray-control.vue?vue&type=template&id=2dc146a2&scoped=true&"
import script from "./vue-qz-tray-control.vue?vue&type=script&lang=js&"
export * from "./vue-qz-tray-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc146a2",
  null
  
)

export default component.exports